import { Button } from "@shopify/polaris";
import { useResendEmailMutationMutation } from "../../../store/store/slices/MailRTK";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { showToast } from "../../../store/store/slices/AlertSlice";

const ResendEmail = ({
  account_id,
  email,
}: {
  account_id: string;
  email: string;
}) => {
  const dispatch = useDispatch();
  const [resendVerificationEmail, { isLoading, isError, isSuccess, error }] =
    useResendEmailMutationMutation();

  useEffect(() => {
    if (isError) {
      dispatch(
        showToast({
          error: true,
          message:
            error?.data?.errors[0]?.msg ||
            "Something went wrong while sending email",
          visible: true,
        })
      );
    }
    if (isSuccess) {
      dispatch(
        showToast({
          error: false,
          message: "Email sent",
          visible: true,
        })
      );
    }
  }, [isLoading, isError, isSuccess]);

  const onResendUserEmailVerificationHandler = async () => {
    await resendVerificationEmail({ account_id, email });
  };
  return (
    <Button
      onClick={onResendUserEmailVerificationHandler}
      disabled={isLoading}
      loading={isLoading}
    >
      Send verification email
    </Button>
  );
};

export default ResendEmail;
